import { render, staticRenderFns } from "./shipmentSelect1.vue?vue&type=template&id=2697364d"
import script from "./shipmentSelect1.vue?vue&type=script&lang=js"
export * from "./shipmentSelect1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports